import api from './en.api.ts';
import common from './en.common.ts';

export default {
  page: {
    priceCalculator: {
      companyName: 'Company Name',
      email: 'E-Mail',
      headline: 'Price Calculator',
      title: 'Price Calculator',
      sites: 'Sites',
      assets: 'Assets',
      displayName: 'Name',
      description: 'Description',
      assetType: 'Asset Type',
      status: 'Status',
      panels: {
        company: 'Company',
        sites: 'Sites',
        site: 'Site {0}',
        license: 'License',
        module: 'Module | Modules',
        price: 'Price | Prices',
        contact: 'Contact | Contacts',
        project: 'Project | Projects',
        application: 'Application | Applications',
        calculation: 'Calculation | Calculations',
        environment: 'Environment | Environments',
      },
      form: {
        company: {
          customerType: 'Customer Type',
          customerAge: 'Customer Age (years)',
        },
        project: {
          projectType: 'Project type',
          currency: 'Currency',
        },
        license: {
          license: 'License',
          model: 'License Model',
          status: 'Status',
          duration: 'Duration',
          individualPurchase: 'Individual Purchase',
          ssa: 'Service Agreement',
        },
        site: {
          displayName: 'Name',
          description: 'Description',
        },
        asset: 'Asset | Assets',
      },
      duration: 'Duration  ({month} Months) | Durations ({month} Months)',
      companies: {
        showCalculation: 'Show Calculation | Show Calculations ({0})',
        confirmDelete: {
          header: 'Delete company "{companyName}"?',
          message: 'This can\'t be undone.',
        },
        errors: {
          noCompany: 'No company selected',
          updateCompany: 'An error occurred while updating the company',
          createCompany: 'An error occurred while creating the company',
          deleteCompany: 'An error occurred while deleting the company',
        },
      },
      settings: {
        application: 'Application',
        companyType: 'Customer Type',
        minSites: 'Min. Sites',
        maxSites: 'Max. Sites',
        unlimited: 'Unlimited',
        modulePrice: 'Module Price',
        errors: {
          updateSettings: 'An error occurred while saving the settings',
        },
      },
      projects: {
        confirmDelete: {
          header: 'Delete project "{displayName}"?',
          message: 'This can\'t be undone.',
        },
        errors: {
          updateProject: 'An error occurred while updating the project',
          createProject: 'An error occurred while creating the project',
          deleteProject: 'An error occurred while deleting the project',
        },
      },
    },
  },

  common,
  api,
};
